export function ProductCardSkeleton() {
  return (
    <div className="flex h-full flex-col animate-pulse">
      <div className="aspect-square mb-6 rounded-xl bg-surface-container" />
      <div className="h-2.5 w-16 rounded-full bg-surface-container mb-3" />
      <div className="h-4 w-3/4 rounded-full bg-surface-container mb-2" />
      <div className="h-3 w-20 rounded-full bg-surface-container" />
    </div>
  );
}

export function ProductGridSkeleton({ count = 8 }: { count?: number }) {
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-x-gutter gap-y-12">
      {Array.from({ length: count }, (_, index) => (
        <ProductCardSkeleton key={index} />
      ))}
    </div>
  );
}
